<template>
  <span>
    <input
      multiple
      type="file"
      ref="fileinput"
      :accept="accept"
      style="display: none"
      @change="onFileSelected"
    /> 
    <!-- <v-btn  v-bind="$attrs" @click="$refs.fileinput.click()" class="mx-0 shadow">{{ label }}</v-btn> -->
    <v-btn color="secondary" small v-bind="$attrs" @click="$refs.fileinput.click()" class="mx-0 shadow" icon>
      <v-icon>add</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: "file-chooser",
  inheritAttrs: false,
  props: {
    label: {
      default: "Choose File",
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      accept: [
        "text/plain",
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/zip",
        "application/pdf",
        "application/msword",
        "application/vnd.ms-excel",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ],
    };
  },
  methods: {
    onFileSelected(event) {
      for (const file of event.target.files) {
        if (this.accept.includes(file.type) && file.size < 10 * 1024 * 1024)
          this.value.push(file);
        else this.$snackbar.error($t('file_max_notation'));
      }

      this.$emit("input", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>